import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function FormRow({ className, children }) {
  return <div className={clsx('row', className)}>{children}</div>
}

FormRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}
